import React, { useEffect, useState } from 'react';
import { observer, inject } from 'mobx-react';
import BoxTwoIcon from '../svg/BoxTwoIcon';
import MiniCartContent from './MiniCartContent';
import CartNotification from './CartNotification';
import { trackViewCart } from '@/utils/tracking';

const MiniCart = inject('wooCommerceStore', 'studioStore')(observer(({ wooCommerceStore, studioStore }) => {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);

  const productCount = isClient ? wooCommerceStore.cart.length : 0;

  const clearCart = () => {
    wooCommerceStore.clearCart();
    wooCommerceStore.toggleCart();
  };

  const handleToggleCart = () => {
    wooCommerceStore.toggleCart();
    if (wooCommerceStore.isCartOpen) {
      trackViewCart(wooCommerceStore.cart);
    }
  };

  return (
    <>
      <div className="mini-cart-container ms-2 my-2">
        <div data-testid="cart-icon" className="mini-cart-icon relative rounded-full p-4 w-[70px] md:w-[110px] h-[70px] md:h-[110px]" onClick={handleToggleCart} style={{backgroundColor: studioStore?.settings?.colors?.primary_color}}>
          <BoxTwoIcon width="100%" height="100%" fill="#ffffff"/>
          <div data-testid="cart-count" className="cart-count absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gray-100 w-[16px] h-[16px] md:w-[32px] md:h-[32px] text-center font-semibold text-sm md:text-xl -mt-[5px] leading-tight md:leading-8 text-primary-studio">
            {productCount}
          </div>
        </div>
        <MiniCartContent toggleCart={handleToggleCart} clearCart={clearCart} productCount={productCount} cartItems={wooCommerceStore.cart} isOpen={wooCommerceStore.isCartOpen} />
      </div>
      <CartNotification />
    </>
  );
}));

export default MiniCart;
